// Training Type

import { Component, ViewChild } from '@angular/core';
import { Message, SelectItem, ConfirmationService, ConfirmEventType, TreeNode } from 'primeng/api';
import { link, breadcrumb, stat } from 'src/app/admin/layout/header/header.component';
import { DynamicFormComponent } from 'src/app/misc/component/dynamic-form/dynamic-form.component';
import { QuestionBase } from 'src/app/misc/component/dynamic-form/question-base';
import { DropdownQuestion } from 'src/app/misc/component/dynamic-form/question-dropdown';
import { TextboxQuestion } from 'src/app/misc/component/dynamic-form/question-textbox';
import { DataService } from 'src/app/services/data.service';
import { PermissionHandlerService } from 'src/app/services/permission-handler.service';
import icons from '../../../../misc/data/icons.json';
import { CheckBoxQuestion } from 'src/app/misc/component/dynamic-form/question-checkbox';
import { NumberQuestion } from 'src/app/misc/component/dynamic-form/question-number';
import { OrgUnitsService } from 'src/app/services/org-units.service';
import { TreeSelectQuestion } from 'src/app/misc/component/dynamic-form/question-treeselect';
import { TranslatorPipe } from 'src/app/services/translator.pipe';
import { IconBoxQuestion } from 'src/app/misc/component/dynamic-form/question-iconbox';

@Component({
  selector: 'app-training-type',
  templateUrl: './training-type.component.html',
  styleUrls: ['./training-type.component.scss']
})
export class TrainingTypeComponent {
  skeleton = true;

  @ViewChild(DynamicFormComponent) DynamicFormComponent:
    | DynamicFormComponent
    | any;

  messages: Message[] = [];

  header = this.translate('Training Settings');
  links: link[] = [];

  translator: TranslatorPipe = new TranslatorPipe()


  breadcrumbs: breadcrumb[] = [{ name: this.translate('Training Settings'), link: 'training/type' }]
  stats: stat[] = [];

  catdata: any[] = [];

  data: any[] = [];
  iconOptions: SelectItem[] = [];
  questions: QuestionBase<string>[] = [];

  // Update data
  updateModal = false;
  updateData: any;
  updateQuestions: any;

  //tree data
  treeData: TreeNode[] = [];
  allowedRight = ['Ministries/Entities', 'Organisational Units']
  singleOUIDs: string[] = ['64ecbe4ff6c283d49c8f3d61', '64edba9b9b8555d3669790dc', '654e867bb9f4c5b8996191c5'];

  basicTrainings = ['WEEKLY', 'Unified session', 'New Branch', 'Skill Training']

  translate(key: string) {
    let translator: TranslatorPipe = new TranslatorPipe();
    return translator.transform(key);
  }


  constructor(
    private dataService: DataService,
    private confirmationService: ConfirmationService,
    public permissionService: PermissionHandlerService,
    private orgUnits: OrgUnitsService,
  ) { }

  ngOnInit() {
    icons.forEach((icon: { i: string; n: string }) => {
      this.iconOptions.push({ label: icon.n, icon: icon.i, value: icon.i });
    });

    this.iconOptions = this.iconOptions.sort((a, b) => {
      if (a.label && b.label) {
        if (a.label < b.label) {
          return -1;
        }
        if (a.label > b.label) {
          return 1;
        }
        return 0;
      } else {
        return 0;
      }
    });

    this.getTreeData().then(() => {
      this.getTrainingTypes();
      this.makequestion();
    })
  }

  async getTreeData() {
    this.treeData = await this.orgUnits.getOrgUnitsMainPage(this.allowedRight);
  }

  getTrainingTypes = async () => {
    try {
      let res = await this.dataService.postData('training-type/get/?offset=1000&page=1', {});
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('Error'), detail: res.msg },
        ];
        return;
      }
      this.catdata = res.data;
      this.data = []
      this.catdata.forEach((item: any) => {
        let actions = !this.basicTrainings.includes(item.name) ? [
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
          {
            n: 'Delete',
            i: 'pi pi-times',
            s: 'p-button-rounded p-button-danger p-button-text p-button-raised',
          },
        ] : [
          {
            n: 'Update',
            i: 'pi pi-file-edit',
            s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
          },
        ]
        this.data.push({

          "#": { n: item._id, i: 'pi pi-angle-left' },
          'اسم النوع': { n: item.arabic, i: item.icon },
          'الحالة': {
            n: item.active,
            i: item.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
          },
          Action: actions,
        });
      });
      this.updateTypeCounts();
      this.skeleton = false;
      console.log('data ou catagory => ', this.catdata, this.data);
    } catch (error) {
      console.log(error);
    }
  };

  makequestion() {
    this.questions = [
      new TextboxQuestion({
        key: 'name',
        label: this.translate('training type name'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-6 col-sm-12 col-6',
      }),

      new TextboxQuestion({
        key: 'arabic',
        label: this.translate('training type name in arabic'),
        required: true,
        order: 1,
        icon: 'pi pi-file',
        className: 'col-md-6 col-sm-12 col-12',
      }),

      new DropdownQuestion({
        key: 'icon',
        label: this.translate('Icons'),
        required: true,
        options: this.iconOptions,
        filter: true,
        order: 3,
        className: 'col-md-6 col-sm-12 col-12',
      }),


      new NumberQuestion({
        key: 'number_of_sessions',
        label: this.translate('Number of sessions'),
        required: true,
        order: 4,
        className: 'col-md-6 col-sm-12 col-12',
      }),

      new TreeSelectQuestion({
        key: 'allowed_ou',
        label: this.translate('allowed ou'),
        treeOptions: this.treeData,
        order: 6,
        icon: 'pi pi-file',
        className: 'col-md-12 col-sm-12 col-12',
        filter: true,
        selectionMode: 'multiple',
      }),



      new DropdownQuestion({
        key: 'active',
        label: this.translate('the condition'),
        options: [
          { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
          { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
        ],
        order: 4,
        className: 'col-md-6 col-sm-12 col-12',
        value: true,
        visibility: "false"
      }),
      new CheckBoxQuestion({
        key: 'add_assessment',
        label: this.translate('the exams'),
        order: 1,
        className: 'col-6 col-sm-12 col-12',
        value: false,
      }),
      new CheckBoxQuestion({
        key: 'add_survey',
        label: this.translate('Polls'),
        order: 1,
        className: 'col-6 col-sm-12 col-12',
        value: false,
      }),
      new CheckBoxQuestion({
        key: 'online_session',
        label: this.translate('online'),
        order: 1,
        className: 'col-6 col-sm-12 col-12',
        value: false,
      }),
      new CheckBoxQuestion({
        key: 'onside_session',
        label: this.translate('In attendance'),
        order: 1,
        className: 'col-6 col-sm-12 col-12',
        value: false,
      }),
      new CheckBoxQuestion({
        key: 'video_session',
        label: this.translate('Via videos'),
        order: 1,
        className: 'col-6 col-sm-12 col-12',
        value: false,
      }),
      new CheckBoxQuestion({
        key: 'certificate',
        label: this.translate('Certificate'),
        order: 1,
        className: 'col-6 col-sm-12 col-12',
        value: false,
      })
    ];
  }

  flattenTree(root: TreeNode[]): any[] {
    const result: any[] = [];
    root.map(e => this.flattenNode(e, result))
    // this.flattenNode(root, result);
    return result;
  }

  private flattenNode(node: TreeNode, result: any[]): void {
    result.push((node as any)?._id);
    if (node.children) {
      for (const child of node.children) {
        this.flattenNode(child, result);
      }
    }
  }

  receiveData = async ($event: any) => {
    try {
      let data = $event;

      let ids = this.flattenTree(data.allowed_ou);

      // Remove undefined values
      const filteredIds = ids.filter(id => id !== undefined);

      // Remove duplicates
      const uniqueIds = [...new Set(filteredIds)];

      console.log("Data123123", data);

      let pay = {
        active: data.active,
        arabic: data.arabic,
        icon: data.icon,
        name: data.name,
        allowed_ou: uniqueIds,
        number_of_sessions: data.number_of_sessions,
        permissions: {
          online_session: data.online_session,
          onside_session: data.onside_session,
          video_session: data.video_session,
          add_assessment: data.add_assessment,
          add_survey: data.add_survey,
          certificate:data.certificate
        }
      }
      let res = await this.dataService.postData('training-type/', pay);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: 'خطأ', detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: 'نجاح', detail: res.msg },
      ];
      this.DynamicFormComponent.resetForm();
      this.getTrainingTypes()
      // console.log('test>', res.data._id);
      // this.catdata.push(res.data);
      // this.data.unshift({
      //   "#": { n: res.data._id, i: 'pi pi-angle-left' },
      //   'اسم النوع': { n: data.arabic, i: data.icon },
      //   'الحالة': {
      //     n: data.active,
      //     i: data.active ? 'pi pi-check-circle' : 'pi pi-check-circle',
      //   },
      //   Action: [
      //     {
      //       n: 'Update',
      //       i: 'pi pi-file-edit',
      //       s: 'p-button-rounded p-button-warning p-button-text p-button-raised',
      //     },
      //   ],
      // });

      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  UpdateData = async ($event: any) => {
    try {
      let data: any = $event;

      let ids = this.flattenTree(data.allowed_ou);

      // Remove undefined values
      const filteredIds = ids.filter((id) => id !== undefined);

      // Remove duplicates
      const uniqueIds = [...new Set(filteredIds)];

      data._id = this.updateData._id;
      let pay = {
        _id: data._id,
        active: data.active,
        arabic: data.arabic,
        icon: data.icon,
        name: data.name,
        allowed_ou: uniqueIds,
        number_of_sessions: data.number_of_sessions,
        permissions: {
          online_session: data.online_session,
          onside_session: data.onside_session,
          video_session: data.video_session,
          add_assessment: data.add_assessment,
          add_survey: data.add_survey,
          certificate: data.certificate,
        },
      };
      let res = await this.dataService.postData(
        'training-type/',
        pay,
        'PUT',
        false
      );
      if (res.error) {
        this.messages = [
          {
            severity: 'error',
            summary: this.translate('Error'),
            detail: res.msg,
          },
        ];
        return;
      }
      this.messages = [
        {
          severity: 'success',
          summary: this.translate('success'),
          detail: res.msg,
        },
      ];
      window.location.reload();
      this.updateModal = false;
      this.updateData = undefined;
      // updating in table
      const myObject = this.data.find((item) => item['#'].n === data._id);
      if (myObject) {
        (myObject['اسم النوع'].n = data.arabic),
          (myObject['اسم النوع'].i = data.icon);
        myObject['الحالة'].n = data.active;
        myObject['الحالة'].i = data.active
          ? 'pi pi-check-circle'
          : 'pi pi-check-circle';
      }

      this.data.map((e, i) => {
        if (e['#'].n === data._id) {
          this.data[i] = myObject;
          return;
        }
      });

      this.catdata.map((e, i) => {
        if (e._id === data._id) {
          this.catdata[i] = data;
          return;
        }
      });
      console.log(this.catdata);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  actionCall($event: any) {
    switch ($event.action) {
      case 'Delete':
        this.confirm({
          message: this.translate('Are you sure you want to do this?'),
          header: this.translate('Comfirm message heading'),
          icon: 'pi pi-exclamation-triangle',
          action: () => this.deleteCatagory($event.id),
        });
        break;
      case 'Update':
        this.catdata
        const update = this.catdata.find((item) => item._id == $event.id);
        this.updateData = { ...update, ...update?.permissions }

        console.log("ASDASD", this.updateData.allowed_ou);

        let selectedOU = this.findNodeById(this.treeData, this.updateData.allowed_ou.map((item: { _id: any; }) => item._id));
        const selectionMode = this.singleOUIDs.includes(this.updateData._id) ? 'single' : 'multiple';

        this.updateQuestions = [
          new TextboxQuestion({
            key: 'name',
            label: this.translate('training type name'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.name,
            className: 'col-6',
            disable: true
          }),

          new TextboxQuestion({
            key: 'arabic',
            label: this.translate('training type name in arabic'),
            required: true,
            order: 1,
            icon: 'pi pi-file',
            value: this.updateData.arabic,
            className: 'col-6',
          }),

          new DropdownQuestion({
            key: 'icon',
            label: this.translate('Icons'),
            required: true,
            options: this.iconOptions,
            filter: true,
            order: 3,
            value: this.updateData?.icon,
            className: 'col-6',
          }),

          new NumberQuestion({
            key: 'number_of_sessions',
            label: this.translate('Number of sessions'),
            value: this.updateData?.number_of_sessions,
            required: true,
            order: 4,
            className: 'col-md-6 col-sm-6 col-6',
          }),

          new TreeSelectQuestion({
            key: 'allowed_ou',
            label: this.translate('allowed ou'),
            treeOptions: this.treeData,
            value: selectedOU,
            order: 6,
            icon: 'pi pi-file',
            className: 'col-md-6 col-sm-6 col-6',
            filter: true,
            selectionMode: selectionMode,
          }),


          new DropdownQuestion({
            key: 'active',
            label: this.translate('the condition'),
            required: true,
            value: this.updateData?.active,
            options: [
              { label: this.translate('active'), icon: 'pi pi-check-circle', value: true },
              { label: this.translate('Inactive'), icon: 'pi pi-times-circle', value: false },
            ],
            order: 4,
            className: 'col-6',
          }),
          new CheckBoxQuestion({
            key: 'add_assessment',
            label: this.translate('the exams'),
            order: 1,
            className: 'col-6 col-sm-12 col-12',
            value: this.updateData.add_assessment,
          }),
          new CheckBoxQuestion({
            key: 'add_survey',
            label: this.translate('Polls'),
            order: 1,
            className: 'col-6 col-sm-12 col-12',
            value: this.updateData.add_survey,
          }),
          new CheckBoxQuestion({
            key: 'online_session',
            label: this.translate('online'),
            order: 1,
            className: 'col-6 col-sm-12 col-12',
            value: this.updateData.online_session,
          }),
          new CheckBoxQuestion({
            key: 'onside_session',
            label: this.translate('In attendance'),
            order: 1,
            className: 'col-6 col-sm-12 col-12',
            value: this.updateData.onside_session,
          }),
          new CheckBoxQuestion({
            key: 'video_session',
            label: this.translate('Via videos'),
            order: 1,
            className: 'col-6 col-sm-12 col-12',
            value: this.updateData.video_session,
          }),
          new CheckBoxQuestion({
            key: 'certificate',
            label: this.translate('Certificate'),
            order: 1,
            className: 'col-6 col-sm-12 col-12',
            value: this.updateData.certificate,
          })
        ];
        this.updateModal = true;
        break;
      default:
        break;
    }
  }

  findNodeByName(data: any[], nodeName: any): any | undefined {
    for (const node of data) {
      if (node._id === nodeName) {
        return node;
      }

      if (node.children) {
        const result = this.findNodeByName(node.children, nodeName);
        if (result) {
          return result;
        }
      }
    }

    return undefined;
  }

  findNodeById(data: any[], nodeIds: any[]): any[] {
    const result: any[] = [];

    for (const nodeId of nodeIds) {
      const foundNode = this.findNodeByName(data, nodeId);
      if (foundNode) {
        result.push(foundNode);
      }
    }

    return result;
  }

  deleteCatagory = async (id: string) => {
    try {
      let res = await this.dataService.deleteData(`training-type/${id}`);
      if (res.error) {
        this.messages = [
          { severity: 'error', summary: this.translate('Error'), detail: res.msg },
        ];
        return;
      }
      this.messages = [
        { severity: 'success', summary: this.translate('success'), detail: res.msg },
      ];
      this.data = this.data.filter((item) => item['#'].n !== id);
      this.catdata = this.data.filter((item) => item._id === id);
      this.updateTypeCounts();
    } catch (error) {
      console.log(error);
    }
  };

  confirm(parems: any) {
    this.confirmationService.confirm({
      message: parems.message,
      header: parems.header,
      icon: parems.icon,
      acceptLabel: this.translate('Yes'),
      rejectLabel: this.translate('no'),
      accept: () => {
        parems.action();
        return true;
      },
      reject: (type: any) => {
        switch (type) {
          case ConfirmEventType.REJECT:
            return false;
          case ConfirmEventType.CANCEL:
            return false;
          default:
            return false;
        }
      },
    });
  }

  private updateTypeCounts(): void {
    let activeCount = this.catdata.filter((e) => e.active === true).length;
    let inactiveCount = this.catdata.length - activeCount;
    this.stats = [
      { name: this.translate('active'), number: activeCount, icon: 'pi pi-check-circle' },
      { name: this.translate('Inactive'), number: inactiveCount, icon: 'pi pi-times-circle' },
    ];
  }
}